import { DatePicker, Input, Select, Table, Tag, Typography } from "antd";
import GlassPanel from "../../components/common/glassPanel";

const { Text } = Typography;

const operationRows = [
  { key: "1", queue: "Intake review", owner: "Ops Desk", workload: 42, sla: "28 min", status: "Healthy", assignee: "Sharon", updatedAt: "09:12" },
  { key: "2", queue: "Verification", owner: "Trust & Safety", workload: 18, sla: "2.1 h", status: "Watch", assignee: "Dennis", updatedAt: "08:41" },
  { key: "3", queue: "Payouts", owner: "Finance Ops", workload: 9, sla: "6.4 h", status: "At risk", assignee: "Amina", updatedAt: "09:03" },
  { key: "4", queue: "Escalations", owner: "Support", workload: 13, sla: "44 min", status: "Healthy", assignee: "Mercy", updatedAt: "09:18" },
];

export default function WheelsOperationsScreen() {
  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel
        eyebrow="Wheels"
        title="Marketplace Operations"
        actions={
          <div className="flex flex-wrap gap-2">
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All queues" },
                { value: "ops", label: "Ops Desk" },
                { value: "trust", label: "Trust & Safety" },
                { value: "finance", label: "Finance Ops" },
              ]}
              style={{ width: 150 }}
            />
            <DatePicker placeholder="Updated since" />
            <Input.Search placeholder="Search queue or assignee" style={{ width: 240 }} />
          </div>
        }
      >
        <Text type="secondary">
          Vehicle-specific operational queues live in the Wheels module instead of the common internal layer.
        </Text>
      </GlassPanel>

      <GlassPanel title="Queue Health">
        <Table
          rowKey="key"
          size="small"
          pagination={{ pageSize: 8, showSizeChanger: false }}
          dataSource={operationRows}
          columns={[
            { title: "Queue", dataIndex: "queue" },
            { title: "Owner", dataIndex: "owner" },
            { title: "Open Work", dataIndex: "workload" },
            { title: "SLA", dataIndex: "sla" },
            { title: "Assignee", dataIndex: "assignee" },
            { title: "Updated", dataIndex: "updatedAt" },
            {
              title: "Status",
              dataIndex: "status",
              render: (value: string) => <Tag color={value === "Healthy" ? "success" : value === "Watch" ? "warning" : "error"}>{value}</Tag>,
            },
          ]}
        />
      </GlassPanel>
    </div>
  );
}
